<template>
  <article>
    <v-layout row wrap justify-space-around align-center class="pa-3">
      <v-flex xs12 md4 class="text-xs-center text-md-left">
        <div class="caption grey--text">Error Budget</div>
        <div>
          <v-progress-circular :value="budgetPct" :size="60" color="error">
            {{ budgetPct }}%
          </v-progress-circular>
        </div>
      </v-flex>
      
      <v-flex xs6 md4>
        <div class="caption grey--text">SLO Name</div>
        <div class="subheading">{{ slo.name }}</div>
      </v-flex>
      <v-flex xs6 md4>
        <div class="caption grey--text">App Name</div>
        <div class="subheading">{{ slo.appName }}</div>
      </v-flex>
    </v-layout>
  </article>
</template>

<script>
export default {
  name: "SLOAtRisk",
  props: {
    slo: {
      type: Object,
      required: true
    }
  },
  computed: {
    budgetPct() {
      var pct = 100.0 * this.slo.currentErrorBudget.remainingBudget / this.slo.currentErrorBudget.totalBudget;
      return pct.toFixed(1);
    },
  }
};
</script>
